import axios from 'axios';
import config from '../config';

const environment = window.location.hostname === 'localhost' ? 'development' : 'production';

const API_BASE = config[environment].apiUrl;

const api = axios.create({
    baseURL: API_BASE,
    timeout: 30000,
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request Interceptor
api.interceptors.request.use(
    (request) => {
        const token = localStorage.getItem('token');
        if (token) {
            request.headers.Authorization = `Bearer ${token}`;
        }

        return request;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');

            // Redirect to login page
            // window.location.href = "/auth/signin";
        }

        return Promise.reject(error);
    }
);

export default api;
